import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';

const RoleGuard = ({ children, allowedRoles = [], requireSuper = false, forbidSuper = false }) => {
    const { isLoggedIn, role, user } = useAuth();
    const navigate = useNavigate();
    const currentUser = Array.isArray(user) ? user[0] : user;
    const isSuperUser = Boolean(currentUser?.is_super === true || currentUser?.is_super === 't' || currentUser?.is_super === 1);

    let isAllowed = allowedRoles.length === 0 || allowedRoles.includes(role);
    if (requireSuper) {
        isAllowed = isAllowed && isSuperUser;
    }
    if (forbidSuper) {
        isAllowed = isAllowed && !isSuperUser;
    }

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('login', { replace: true });
            return;
        }

        if (!isAllowed) {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoggedIn, isAllowed, navigate]);

    if (!isLoggedIn || !isAllowed) {
        return null;
    }

    return children;
};

RoleGuard.propTypes = {
    children: PropTypes.node,
    allowedRoles: PropTypes.arrayOf(PropTypes.string),
    requireSuper: PropTypes.bool,
    forbidSuper: PropTypes.bool
};

export default RoleGuard;
